export default __webpack_public_path__ + "static/media/attendance.40aabe94.svg";